// extracted by mini-css-extract-plugin
module.exports = {"preserveOutline":"Item_preserveOutline__1JP1o","item":"Item_item__otF5H Item_preserveOutline__1JP1o","itemSvg":"Item_itemSvg__2A5q7","itemText":"Item_itemText__2C441"};